module.exports = __webpack_public_path__ + "img/云仓物流ico.0a880685.png";